/** @prettier */
import { API_ROOT, makeRequest } from "../services/qbankApi";
import { TestMode } from "../Test/models";

export type TestProgressData = {
    testUuid: string;
    createdDate: Date; // TODO: Date
    testName: string;
    mode: TestMode;
    answeredQuestions: number;
    totalQuestions: number;
};

export type DashboardData = {
    correctQuestions: number;
    incorrectQuestions: number;
    testsCreated: number;
    totalQuestions: number;
    unansweredQuestions: number;
    unusedQuestions: number;
    pausedTests: number;
    pausedTestsList: TestProgressData[];
};

export async function getDashboardData(userId: string, productId: string) {
    const url = `${API_ROOT}dashboard/users/${userId}/products/${productId}`;
    return (await (await makeRequest("GET", url)).json()) as DashboardData;
}
